import { render } from "./List.vue?vue&type=template&id=272b3be0&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=272b3be0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-272b3be0"

export default script